/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S6_P3Inputs */

const en_guide_json_rest_api_s6_p3 = /** @type {(inputs: Guide_Json_Rest_Api_S6_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finally, be deliberate about null and missing fields. Returning null says the value is known to be empty, while omitting the key says nothing at all about it. Pick one meaning, document it, and apply it everywhere so clients can trust what they receive.`)
};

const ko_guide_json_rest_api_s6_p3 = /** @type {(inputs: Guide_Json_Rest_Api_S6_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마지막으로 null과 누락 필드를 의도적으로 다루세요. null을 반환하는 것은 값이 비어 있음을 안다는 뜻이고, 키를 생략하는 것은 그에 대해 아무 말도 하지 않는 것입니다. 한 가지 의미를 정하고 문서화한 뒤 어디에나 일관되게 적용해, 클라이언트가 받은 데이터를 신뢰할 수 있게 하세요.`)
};

const ja_guide_json_rest_api_s6_p3 = /** @type {(inputs: Guide_Json_Rest_Api_S6_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後に、null と欠落フィールドを意図的に扱いましょう。null を返すのは値が空だと分かっているという意味で、キーを省くのはそれについて何も述べていないということです。一つの意味を決めて文書化し、どこでも一貫して適用して、クライアントが受け取ったデータを信頼できるようにしましょう。`)
};

/**
* | output |
* | --- |
* | "Finally, be deliberate about null and missing fields. Returning null says the value is known to be empty, while omitting the key says nothing at all about it..." |
*
* @param {Guide_Json_Rest_Api_S6_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s6_p3 = /** @type {((inputs?: Guide_Json_Rest_Api_S6_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S6_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s6_p3(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s6_p3(inputs)
	return ja_guide_json_rest_api_s6_p3(inputs)
});